<template>
  <div v-if="canVerb(resource, 'index')">
    <b-overlay
      center
      :show="(!isLoading && !hasFilterLoaded) || isConsolidating"
      rounded="sm"
    >
      <actions-toolbar>
        <template #filters>
          <div class="status-filter">
            <div class="pill-wrapper my-3">
              <span
                class="pill"
                v-for="(value, name, index) in activeFilters"
                :key="index"
                data-color="white"
              >
                <span v-b-toggle.sidebar-1 :data-filter="name"
                  ><strong>{{ sidebarFilterName(name, context) }}</strong
                  >:&nbsp;{{ sidebarFilterValue(name, value) }}</span
                >
                <span tabindex="0">
                  <span
                    @click="resetSingleSidebarFilter(name)"
                    title="Rimuovi filtro"
                    >×</span
                  >
                </span>
              </span>
              <template v-if="countActiveFilters">
                <span
                  class="pill"
                  data-color="alert"
                  @click="resetAllFilters()"
                  title="Rimuovi i filtri e apri il pannello per una nuova ricerca"
                >
                  <span
                    ><strong>Reset ({{ countActiveFilters }})</strong></span
                  >
                  <span><span>×</span></span>
                </span>
              </template>
            </div>
          </div>
        </template>
        <b-button-group
          v-b-toggle.sidebar-1
          :class="`filter-button-group btn--smaller btn--transparent align-items-center gap-3${
            countActiveFilters ? ' active' : ''
          }`"
          :title="getDefaultFilterMessage()"
        >
          <base-icon name="filters" width="23" height="23" />
          <span style="font-size: 14px; font-weight: 500">{{
            computedFilterTitle
          }}</span>
        </b-button-group>
        <b-dropdown
          class="actions-dropdown"
          right
          size="sm"
          toggle-class="btn--smaller btn--transparent"
          title="Genera o crea quietanzamenti"
          v-if="canVerb(resource, 'store')"
        >
          <template #button-content>
            <b-icon icon="plus-circle" width="20" height="20"></b-icon>
            <span style="font-size: 14px; font-weight: 500">Azioni</span>
          </template>
          <b-dropdown-group
            v-for="(group, gi) in paymentActions"
            :key="gi"
            :id="`dropdown-group-actions-${gi}`"
            :header="group.header"
          >
            <b-dropdown-item
              v-for="action in group.items"
              :key="action.type"
              @click="onAddInsurancePayment(action.type)"
            >
              <b-icon :icon="action.icon" class="mr-2"></b-icon
              >{{ action.label }}
            </b-dropdown-item>
          </b-dropdown-group>
        </b-dropdown>
        <b-button
          class="btn--smaller btn--transparent"
          type="button"
          variant="secondary"
          size="sm"
          :disabled="!computePerformedSearch"
          @click="openConsolidateModal()"
          title="Consolida i titoli delle quietanze che rispettano i filtri attivi"
        >
          <b-icon icon="lock-fill" aria-hidden="true"></b-icon>
          Consolida
        </b-button>
        <export-options
          :exportUrl="exportUrl"
          :repository="repository"
          :resource="resource"
          :tableRef="$refs[tableRef]"
          :filter="filter"
          :options="[
            {
              code: 'EXPOINPA',
              label: null,
              formats: ['csv', 'pdf'],
            },
            {
              code: 'REDESCACO',
              label: null,
              formats: ['pdf'],
            },
          ]"
        ></export-options>
        <b-dropdown
          ref="columnsDropdown"
          right
          size="sm"
          toggle-class="btn--smaller btn--transparent"
        >
          <template #button-content>
            <b-icon icon="gear" width="20" height="20"></b-icon>
            <span style="font-size: 14px; font-weight: 500">{{
              dropdownLabel
            }}</span>
          </template>
          <div>
            <b-dropdown-group
              id="dropdown-group-1"
              header="Seleziona le colonne da nascondere"
            >
              <b-dropdown-form @submit.stop.prevent>
                <b-form-checkbox-group
                  v-model="hiddenKeys"
                  :options="hideableFieldOptions"
                  text-field="text"
                  value-field="value"
                  stacked
                  class="mb-3"
                />
                <b-button
                  class="btn--smaller btn--transparent"
                  type="button"
                  variant="secondary"
                  size="sm"
                  @click="onToggleColumnsAndClose"
                  >Modifica Colonne
                </b-button>
              </b-dropdown-form>
            </b-dropdown-group>
          </div>
        </b-dropdown>
      </actions-toolbar>
      <div class="table-container">
        <b-sidebar
          id="sidebar-1"
          :title="computedFilterTitle"
          :backdrop="true"
          width="50dvw"
          shadow
          right
          :visible="open_filter"
          :data-open="open_filter"
          @change="onSidebarFilterChange"
        >
          <b-form @submit.prevent="onSearch(filterName)">
            <div class="filter">
              <div class="filter-item" data-cols="2">
                <base-select
                  name="payment_type"
                  label="Tipo"
                  :options="payment_types"
                  v-model="filter.byAttribute.payment_type"
                  :taggable="true"
                  :multiple="true"
                  :closeOnSelect="false"
                />
                <base-select
                  name="status_payment"
                  label="Stato"
                  :options="status_payments"
                  v-model="filter.byAttribute.status_payment"
                  :taggable="true"
                  :multiple="true"
                  :closeOnSelect="false"
                />
              </div>
              <div class="filter-item" data-cols="2">
                <base-select
                  name="selected"
                  label="Mostra solo selezionate (per invio)"
                  :options="[
                    { value: 'Y', text: 'Si' },
                    { value: 'N', text: 'No' },
                  ]"
                  v-model="filter.byCustom.selected"
                />
                <base-select
                  name="sent"
                  label="Quietanza già inviata"
                  :options="sent"
                  v-model="filter.byAttribute.sent"
                />
              </div>
              <div class="filter-item" data-cols="2">
                <base-datepicker
                  name="periodo"
                  label="Periodo da"
                  v-model="filter.byCalendar.from"
                />
                <base-datepicker
                  name="periodo"
                  label="Periodo a"
                  v-model="filter.byCalendar.to"
                />
              </div>
              <div class="filter-item">
                <b-button-group class="mb-3 relative-month-group">
                  <b-button
                    class="btn--transparent btn--x-smaller"
                    @click="setRelativeMonthRange(-1)"
                  >
                    {{ getMonthLabel(-1) }}
                  </b-button>
                  <b-button
                    class="btn--transparent btn--x-smaller"
                    @click="setRelativeMonthRange(0)"
                  >
                    {{ getMonthLabel(0) }}
                  </b-button>
                  <b-button
                    class="btn--transparent btn--x-smaller"
                    @click="setRelativeMonthRange(1)"
                  >
                    {{ getMonthLabel(1) }}
                  </b-button>
                </b-button-group>
              </div>
              <div class="filter-item" data-cols="2">
                <div>
                  <base-select
                    name="cod_prod"
                    label="Produttore"
                    :options="salesmen_select"
                    v-model="filter.byBrokerEnhanced.salesmen"
                    :multiple="true"
                    :closeOnSelect="false"
                    :taggable="salesmen_taggable"
                    :defaultHtmlMultipleSelect="true"
                    @changeTaggable="changeTaggable"
                  >
                    <template #advanced-actions>
                      <b-button
                        :pressed.sync="myToggle"
                        variant="light"
                        class="btn--smaller btn--x-smaller btn--transparent"
                        @click="
                          myToggle ? selectAllBrokers() : deselectAllBrokers()
                        "
                        >{{
                          myToggle ? "Deseleziona tutti" : "Seleziona tutti"
                        }}
                      </b-button>
                      <b-button
                        :pressed.sync="myTogglePO"
                        variant="light"
                        class="btn--smaller btn--x-smaller btn--transparent"
                        @click="
                          myTogglePO
                            ? salesmenOrderByCode()
                            : salesmenOrderByName()
                        "
                        >{{
                          myTogglePO ? "Ordine per nome" : "Ordina per codice"
                        }}
                      </b-button>
                    </template>
                  </base-select>
                </div>
                <base-select
                  name="Compagnia"
                  label="Compagnia"
                  :options="companies"
                  v-model="filter.byInsurer.id"
                  :taggable="true"
                  :multiple="true"
                  :closeOnSelect="false"
                />
              </div>
              <div class="filter-item" data-cols="2">
                <base-select
                  name="Anomalia_Stato"
                  label="Anomalia / Stato"
                  :options="[
                    { value: '0', text: 'Discordanza data' },
                    { value: '1', text: 'Polizza Annullata' },
                    { value: '2', text: 'Polizza disdetta' },
                    { value: '3', text: 'Polizza non perfezionata' },
                    { value: '4', text: 'Polizza senza tacito rinnovo' },
                    { value: '5', text: 'Polizza sospesa' },
                    { value: '6', text: 'Polizza stornata' },
                    { value: '7', text: 'Polizza sostituita' },
                    { value: '10', text: 'Polizza Trasferita' },
                    { value: '8', text: 'Quietanza pagata' },
                    { value: '9', text: 'Rata precedente non incassata' },
                  ]"
                  v-model="filter.byAttribute.error_code"
                  :taggable="true"
                  :multiple="true"
                  :closeOnSelect="false"
                />
                <base-select
                  name="Tipo Polizza"
                  label="Tipo Polizza"
                  :options="risks"
                  v-model="filter.byRiskType.id"
                  :taggable="true"
                  :multiple="true"
                  :closeOnSelect="false"
                />
              </div>
              <div class="filter-item" data-cols="2">
                <base-input
                  name="nominativo"
                  type="text"
                  label="Nominativo"
                  v-model="filter.byRegistry.title"
                  placeholder="Inserisci un nominativo"
                />
                <base-input
                  name="number"
                  type="text"
                  label="Numero Polizza"
                  v-model="filter.byInsurancePolicy.number"
                  placeholder="Inserisci un numero polizza"
                />
              </div>
              <div class="filter-item" data-cols="2">
                <base-select
                  name="Incassabile"
                  label="Incassabile"
                  :options="to_collect_options"
                  v-model="filter.byInsuranceAncillary.to_collect"
                />
                <base-select
                  name="Sepa_SDD"
                  label="Sepa SDD"
                  :options="[
                    { value: 'Y', text: 'Si' },
                    { value: 'N', text: 'No' },
                  ]"
                  v-model="filter.byAttribute.sepa_sdd"
                />
              </div>
              <div class="filter-item" data-cols="2">
                <base-select
                  name="Consolidata"
                  label="Consolidata"
                  :options="to_collect_options"
                  v-model="filter.byInsuranceAncillary.consolidated"
                />
              </div>
              <div class="filter-item" data-type="registry-group">
                <div>
                  <b-button-toolbar>
                    <b-button-group>
                      <base-input
                        :class="{
                          'filter-item-inner-wrapped': true,
                        }"
                        name="Gruppo Anagrafico"
                        label="Gruppo Anagrafico"
                        v-model="form.inpt_label_group"
                        :readonly="true"
                      />
                      <b-button
                        class="btn-quick btn--light"
                        size="sm"
                        text="Button"
                        variant="lisaweb"
                        title="Cerca gruppo anagrafico"
                        @click="openQuickSearchGroup"
                      >
                        <!-- <b-icon icon="search"></b-icon> -->
                        <base-icon
                          name="search"
                          width="14"
                          height="14"
                        ></base-icon>
                      </b-button>
                      <b-button
                        v-if="form.inpt_label_group"
                        class="btn--light btn--alert"
                        size="sm"
                        text="Button"
                        variant="lisaweb"
                        @click="resetGroupId"
                        title="Elimina gruppo anagrafico"
                      >
                        <!-- <base-icon name="trash" width="22" height="22"></base-icon> -->
                        <base-icon
                          name="trash"
                          width="22"
                          height="22"
                        ></base-icon>
                      </b-button>
                    </b-button-group>
                  </b-button-toolbar>
                </div>
              </div>
              <quick-search-group-modal
                ref="quickSearchGroup"
                @input="handleGroupModalInput"
              ></quick-search-group-modal>
              <div class="filter-item" data-type="registry-group-info">
                <div class="details-card-wrapper" v-if="extra_group_full_info">
                  <b-card>
                    <div
                      slot="header"
                      class="d-flex justify-content-between align-items-center"
                    >
                      <p class="mb-0 d-inline-block align-middle">
                        <strong
                          >Informazioni gruppo anagrafico selezionato</strong
                        >
                      </p>
                    </div>
                    <div
                      class="custom-grid-wrapper"
                      v-html="extra_group_full_info"
                    ></div>
                  </b-card>
                </div>
              </div>
              <h3 class="inner-filter-title mt-5">Filtri aggiuntivi</h3>
              <div class="filter-item" data-cols="3">
                <base-select
                  name="Commenti"
                  label="Commenti"
                  :options="comments"
                  v-model="filter.byAttribute.comment"
                />
                <base-input
                  name="CercaTestoCommenti"
                  label="Cerca Testo nei Commenti"
                  v-model="filter.byCustom.comment.value"
                />
                <base-input
                  name="CercaTestoNote"
                  label="Cerca Testo nelle Note"
                  v-model="filter.byCustom.description.value"
                />
              </div>
              <div class="filter-item" data-cols="3">
                <base-select
                  name="related_notes"
                  label="Elenca solo quietanze con note associate"
                  :options="relatedNotesOptions"
                  v-model="filter.byRelatedTasks"
                />
                <base-select
                  name="Pagamento"
                  label="Stato Pagamento"
                  :options="pagamenti"
                  v-model="filter.byInsuranceAncillary.status_ancillary"
                />
                <base-select
                  name="Contraenti"
                  label="Contraenti con più scadenze nel periodo selezionato"
                  :options="contraenti"
                  v-model="filter.byRelations"
                />
              </div>
              <div class="filter-item" data-cols="3">
                <base-select
                  name="Collaborazione"
                  label="Collaborazione"
                  v-model="filter.byBrokerEnhanced.cooperators"
                  :options="cooperators"
                  :taggable="true"
                  :multiple="true"
                  :closeOnSelect="false"
                />
                <base-select
                  name="QuietanzeModificate"
                  label="Quietanze modificate (forzature / cambio premio)"
                  :options="modificate"
                  v-model="filter.byAttribute.modified"
                />
                <base-select
                  name="anagrafica"
                  label="Tipo anagrafica"
                  :options="tipo_anagrafica"
                  v-model="filter.byRegistry.status_registry"
                />
              </div>
              <div class="filter-item" data-cols="2">
                <base-select
                  name="Frazionamento"
                  label="Frazionamento"
                  :options="payment_splitting"
                  v-model="filter.byInsurancePolicy.payment_splitting"
                  :taggable="true"
                  :multiple="true"
                  :closeOnSelect="false"
                />
                <base-select
                  name="Canale"
                  label="Canale di Comunicazione"
                  v-model="filter.byCommunicationChannel"
                  :options="[
                    { value: '0', text: 'E-mail' },
                    { value: '1', text: 'Posta' },
                    { value: '2', text: 'SMS' },
                    { value: '3', text: 'Telefono' },
                    { value: '4', text: 'No Avviso' },
                    { value: '5', text: 'Tramite Capo Gruppo' },
                    { value: 'default', text: 'Canale di default' },
                  ]"
                  :taggable="true"
                  :multiple="true"
                  :closeOnSelect="false"
                />
              </div>
              <div class="filter-item">
                <base-select
                  name="EmptyContact"
                  label="Recapito primario mancante"
                  v-model="filter.byEmptyContact"
                  :options="[
                    { value: 'mail', text: 'Email' },
                    { value: 'cell', text: 'Cellulare' },
                    { value: 'mail,cell', text: 'Email e cellulare' },
                  ]"
                />
              </div>
              <div class="filter-item">
                <base-select
                  name="lastInstallmentOptions"
                  label="Scadenza"
                  :options="lastInstallmentOptions"
                  v-model="filter.byLastInstallment"
                />
                <base-input
                  name="CONV"
                  label="Convenzioni"
                  v-model="filter.byInsurancePolicy.CONV"
                />
              </div>
            </div>
            <div class="actions-filter-sidebar-wrapper">
              <b-button
                type="submit"
                variant="lisaweb"
                size="sm"
                v-b-toggle:sidebar-1
                >Cerca
              </b-button>
              <b-button
                class="btn--transparent btn-reset"
                type="button"
                size="sm"
                @click="onClearFilter(filterName)"
                >Reset
              </b-button>
            </div>
          </b-form>
        </b-sidebar>
        <!-- <button-group-table></button-group-table> -->
        <div
          class="table-wrapper"
          data-type="overflow-x"
          data-table="quietanzamento"
          style="margin-left: 0 !important"
        >
          <insurance-payments
            :onlyActions="['infomodal', 'destroy']"
            :fields="fields"
            @manualFetch="manualFetch"
            :repository="repository"
            :resource="resource"
            :filterName="filterName"
            :loadingSpunte="isLoadingSpunte"
            :performedSearch="computePerformedSearch"
            :filterCount="countActiveFilters"
            :filterOn="{
              byRelations: [
                'byRegistry',
                'byRegistryGroup',
                'byHistory',
                //'byTask',
                'byUser',
              ],
            }"
            :ref="tableRef"
            @rowSelector="onUpdateStatus"
            @selezionato="onUpdateSelected"
            @spunta="onSelectAll"
            @spuntapagina="onSelectPage"
            @toglispunta="onUnselectAll"
            includeRowSelector
            @open_replaced_policy="openReplacedPolicyModal"
            @open_address_book="openAddressBook"
            @updateComment="updateComment"
            @toggle_to_collect="onToggleToCollect"
          >
            <template #selection-actions="{ count }">
              <b-button
                type="button"
                variant="lisaweb"
                class="btn-create btn--smaller"
                :disabled="count === 0"
                @click="onSendCommunications"
                >Invia selezionati ({{ count }})
              </b-button>
            </template>
          </insurance-payments>
        </div>
        <insurance-payment-modal
          :ref="modalRef"
          v-model="frm"
          :beFormCreate="beForm['insurance_payment']"
          :beRulesCreate="beRules['insurance_payment']"
          @create="onCreate"
          @destroy="onDestroy"
        ></insurance-payment-modal>
        <address-book-edit-modal
          v-bind:resourceIds="registry_obj"
          @fetch="forcedFetch"
        >
        </address-book-edit-modal>
        <replaced-policy-detail-modal v-bind:resourceId="replaced_policy_id">
        </replaced-policy-detail-modal>
        <consolidate-modal
          :total="consolidateTotal"
          entity="quietanze"
          @consolidate="onConsolidate"
        ></consolidate-modal>
      </div>
      <template #overlay>
        <div class="text-center">
          <div class="custom-loader"></div>
          <p class="loading-text">Operazione in corso...</p>
        </div>
      </template>
    </b-overlay>
  </div>
  <div v-else class="mt-3">
    <b-icon icon="info-circle" scale="1.00"></b-icon>
    Non hai i permessi
  </div>
</template>

<script>
import BaseIcon from "@/components/BaseIcon";
import InsurancePayments from "@/components/tables/InsurancePayments";
import BaseInput from "@/components/form/BaseInput";
import ExportOptions from "@/components/ExportOptions";
import BaseSelect from "@/components/form/BaseSelect";
import BaseDatepicker from "@/components/form/BaseDatepicker";
import CustomFiltersMixin from "@/mixins/CustomFiltersMixin";
import ConfirmModalMixin from "@/mixins/ConfirmModalMixin";
import { RepositoryFactory } from "@/repositories/RepositoryFactory";
import { mapGetters, mapActions } from "vuex";
import InsurancePaymentModal from "@/components/modals/createInsurancePaymentOptionsModal";
import { prepareFilterQueryString } from "@/utils/forms";
import ReplacedPolicyDetailModal from "@/components/modals/replacedPolicyDetailModal";
import FormMixin from "@/mixins/FormMixin";
import ShowMixin from "@/mixins/ShowMixin";
import { toLocaleCurrency } from "@/utils/strings";
import { fromFirstDay, toLastDay } from "@/utils/dates";
import { toLocaleDate } from "@/utils/dates";
import { toInfoData } from "@/utils/transforms";
import { getVirtualValue } from "@/utils/payments";
import AddressBookEditModal from "@/components/modals/addressBookEditModal";
import QuickSearchGroupModal from "@/components/modals/quickSearchGroup";
import ConsolidateModal from "@/components/modals/consolidateModal";

import moment from "moment";
import SidebarFilterMixin from "../../mixins/SidebarFilterMixin";

moment.locale("it");

// NOTA:
// payment_type == 0 && payable_type == "App\\Models\\BookEntry" allora leggo "book_entry"
// payment_type != 0 && payable_type == "App\\Models\\InsuranceAncillary" allora leggo "insurance_ancillary"

export default {
  mixins: [
    FormMixin,
    ConfirmModalMixin,
    CustomFiltersMixin,
    ShowMixin,
    SidebarFilterMixin,
  ],
  data() {
    return {
      tableIdentifier: "insurance-payments",
      modalResourceId: null,
      exportUrl: null,
      hasFilterLoaded: false,
      isConsolidating: false,
      consolidateTotal: 0,
      consolidateQueryString: null,
      /* Voci del menu Azioni: aprono tutte createInsurancePaymentOptionsModal cambiando
         payment_type. Icone allineate a titleIcon() della modale. */
      paymentActions: [
        {
          header: "Genera",
          items: [{ type: 2, label: "Quietanze", icon: "calendar2-event" }],
        },
        {
          header: "Includi nella generazione",
          items: [
            { type: 0, label: "Sospesi", icon: "bookmark-plus" },
            { type: 3, label: "Acconti", icon: "cash-stack" },
            { type: 1, label: "Arretrati", icon: "calendar2-plus" },
          ],
        },
        {
          header: "Crea",
          items: [{ type: 4, label: "Manuale", icon: "receipt" }],
        },
      ],
      isLoading: false,
      isLoadingSpunte: false,
      formLoaded: false,
      notes: [],
      replaced_policy_id: null,
      old_replaced_policy_id: null,
      new_address_book_id: null,
      old_address_book_id: null,
      new_correspondence_id: null,
      old_correspondence_id: null,
      new_registry_id: null,
      old_registry_id: null,
      extra_group_full_info: null,
      registry_obj: {},
      dropdownLabel: "Colonne",
      hiddenKeys: [], // keys of columns the user wants to HIDE
      activeFilters: {},
      performedSearch: false,
      args: {},
      sent: [
        { value: "Y", text: "Si" },
        { value: "N", text: "No" },
      ],
      selected: [
        { value: "Y", text: "Si" },
        { value: "N", text: "No" },
      ],
      tableRef: "InsurancePaymentsTableRef",
      modalRef: "InsurancePaymentOptionsModal",
      // counterSelezionate: 0,
      lastCreated: null,
      filter: this.initFilter(),
      userId: this.$store.state.auth.user.id,
      group_data: null,
      form: {
        insurance_payment: {},
        inpt_label_group: "",
        quick_value: "",
      },
      beCreateForm: {},
      companies: [],
      risks: [],
      filterName: "filterInsurancePayments",
      resource: "insurance_payments",
      context: "insurance_payments",
      repository: "insurance_payment",
      fields: [
        {
          key: "selezionato",
          label: "",
          sortable: false,
          // thClass viene sovrascritto da CustomFieldsAndActionsMixin: senza .check sul th
          // la regola globale table th:not([aria-sort]):not(.check) blocca i click sulla checkbox
          class: "check",
          thStyle: {
            width: "2px",
          },
          hideable: false,
        },
        // {
        //   key: "rowSelector",
        //   label: "",
        //   sortable: false,
        //   thStyle: {
        //     width: "20px",
        //   },
        // },
        {
          key: "status_payment.text",
          label: "Stato",
          sortable: true,
          sortKey: "status_payment",
          thStyle: {
            width: "80px",
          },
          hideable: false,
        },
        {
          key: "error_code",
          label: "Anomalia / Stato",
          formatter: (value) => this.convertErrorValues(value),
          sortable: true,
          hideable: false,
        },
        {
          key: "payment_type",
          label: this.getDictionary("payment_type", "insurance_payment"),
          sortable: false,
          thStyle: {
            width: "80px",
          },
          hideable: false,
        },
        {
          key: "referring_at",
          label: this.getDictionary("referring_at", "insurance_payment"),
          sortable: true,
          formatter: (value) => toLocaleDate(value),
          thStyle: {
            width: "80px",
          },
          hideable: false,
        },
        {
          key: "payment_splitting",
          label: this.getDictionary("payment_splitting", "insurance_policy"),
          sortable: true,
          sortKey: "byInsurancePolicy.installments",
          hideable: false,
        },
        {
          key: "insurer_code",
          // label: this.getDictionary("insurer"),
          label: "Comp.",
          sortable: true,
          sortKey: "byInsurer.code",
          thStyle: {
            width: "20px",
          },
          hideable: false,
        },
        {
          key: "number",
          label: this.getDictionary("insurance_policy"),
          sortable: true,
          sortKey: "byInsurancePolicy.number",
          thStyle: {
            width: "80px",
          },
          hideable: false,
        },
        {
          key: "branch_and_type",
          label: "Ramo/Tipo/Prod",
          sortable: true,
          sortKey: "byInsuranceRisk.branch_type_product",
          thStyle: {
            width: "80px",
          },
          hideable: false,
        },
        {
          key: "produttore",
          label: this.getDictionary("salesman"),
          sortable: true,
          sortKey: "byBroker.title",
          thStyle: {
            width: "40px",
          },
          hideable: false,
        },
        {
          key: "contraente",
          label: this.getDictionary("contractor"),
          sortable: true,
          sortKey: "byRegistry.title",
          thStyle: {
            width: "200px!important",
          },
          hideable: false,
        },
        {
          key: "address_books",
          // label: this.getDictionary("address_book"),
          label: "Recapiti Primari",
          sortable: false,
          hideable: true,
        },
        {
          key: "gruppo",
          label: "Gruppo",
          sortable: true,
          sortKey: "byRegistryGroup.title",
          thStyle: {
            width: "40px",
          },
          hideable: true,
        },
        {
          key: "gross",
          label: this.getDictionary("gross", "insurance_payment"),
          sortable: true,
          thClass: "text-right",
          thStyle: {
            "text-align": "right",
          },
          tdClass: "text-right",
          formatter: (value) => toLocaleCurrency(value),
          hideable: false,
        },
        {
          key: "diff",
          label: "Diff",
          sortable: true,
          sortKey: "byGross.difference",
          thClass: "text-right",
          thStyle: {
            "text-align": "right",
          },
          tdClass: "text-right",
          hideable: false,
        },
        {
          key: "perc",
          label: "Perc",
          sortable: true,
          sortKey: "byGross.percentage",
          tdClass: "text-right",
          thClass: "text-right",
          hideable: false,
        },
        {
          key: "ultimo",
          label: "Ultimo",
          sortable: true,
          sortKey: "byInsurancePolicy.gross_premium",
          thClass: "text-right",
          thStyle: {
            "text-align": "right",
          },
          tdClass: "text-right",
          hideable: false,
        },
        {
          key: "coass",
          label: "COASS",
          hideable: true,
        },
        {
          key: "communication",
          label: "Canale di Comunicaz.",
          sortable: false,
          tdClass: "text-left",
          thStyle: {
            width: "80px",
            "min-width": "80px",
          },
          hideable: true,
        },
        {
          key: "commento",
          label: "Commento",
          sortable: false,
          stickyColumn: true,
          hideable: true,
        },
        {
          key: "info",
          label: "Info",
          sortable: false,
          stickyColumn: true,
          hideable: false,
        },
      ],
      relatedNotesOptions: [
        { value: "Y", text: "Elenca solo quietanze con note associate" },
      ],
      lastInstallmentOptions: [
        { value: "yes", text: "Solo in scadenza di contratto" },
        { value: "no", text: "Solo scadenze intermedie" },
      ],
      to_collect_options: [
        { value: "Y", text: "Si" },
        { value: "N", text: "No" },
      ],
      iban_options: [
        { value: "Y", text: "SI" },
        // { value: "N", text: "NO" },
      ],
      payment_types: [
        { value: 2, text: "Quietanze" },
        { value: 0, text: "Sospesi" },
        { value: 1, text: "Titoli arretrati" },
        { value: 3, text: "Acconti" },
        { value: 4, text: "Manuale" },
      ],
      status_payments: [
        { value: "0", text: "Valido" },
        { value: "1", text: "Da Validare" },
        { value: "2", text: "Mancante" },
        { value: "3", text: "Incassato" },
        { value: "4", text: "Annullato/Stornato" },
      ],
      pagamenti: [{ value: "0", text: "solo da incassare" }],
      modificate: [{ value: "Y", text: "solo modificate" }],
      salesmen: [],
      salesmen_ids: [],
      salesmen_ordered: [],
      salesmen_select: [],
      salesmen_taggable: true,
      myToggle: false,
      myTogglePO: false,
      cooperators: [],
      payment_splitting: [
        { value: "0", text: "Unico" },
        { value: "1", text: "Mensile" },
        { value: "2", text: "Bimestrale" },
        { value: "3", text: "Trimestrale" },
        { value: "4", text: "Quadrimestrale" },
        { value: "6", text: "Semestrale" },
        { value: "12", text: "Annuale" },
      ],
      comments: [{ value: "!", text: "solo commentate" }],
      contraenti: [{ value: "byMostInExpiry", text: "solo con più scadenze" }],
      tipo_anagrafica: [
        { value: "0", text: "Persona Fisica" },
        { value: "1", text: "Persona Giuridica" },
      ],
      anomalie_errori: {
        0: "Discordanza data",
        1: "Polizza Annullata",
        2: "Polizza disdetta",
        3: "Polizza non perfezionata",
        4: "Polizza senza tacito rinnovo",
        5: "Polizza sospesa",
        6: "Polizza stornata",
        7: "Polizza sostituita",
        10: "Polizza Trasferita",
        8: "Quietanza pagata",
        9: "Rata precedente non incassata",
      },
    };
  },
  components: {
    BaseIcon,
    BaseInput,
    // ButtonGroupTable,
    ExportOptions,
    BaseSelect,
    BaseDatepicker,
    InsurancePayments,
    InsurancePaymentModal,
    ReplacedPolicyDetailModal,
    AddressBookEditModal,
    QuickSearchGroupModal,
    ConsolidateModal,
  },
  computed: {
    countActiveFilters() {
      return Object.keys(this.activeFilters).length;
    },
    computedFilterTitle() {
      return `Filtri${
        this.countActiveFilters ? ` (${this.countActiveFilters})` : ""
      }`;
    },
    computePerformedSearch() {
      return this.performedSearch;
    },
    hideableFieldOptions() {
      // only the fields with hideable: true
      return this.fields
        .filter((f) => f.hideable)
        .map((f) => ({
          text: f.label || f.key, // what user sees
          value: f.key, // the key we store in hiddenKeys
        }));
    },
    frm() {
      return this.form[this.repository];
    },
    pymnt: {
      get() {
        return this.form[this.repository].payment_type;
      },
      set(value) {
        this.form[this.repository].payment_type = value;
      },
    },
    ...mapGetters("lisacomunica_automodal", ["isShowAutoModal"]),
  },
  methods: {
    toInfoData,
    getVirtualValue,
    setRelativeMonthRange(offset = 0) {
      const baseMonth = moment().add(offset, "month");
      this.filter.byCalendar.from = baseMonth
        .clone()
        .startOf("month")
        .format("YYYY-MM-DD");
      this.filter.byCalendar.to = baseMonth
        .clone()
        .endOf("month")
        .format("YYYY-MM-DD");
    },
    getMonthLabel(offset = 0) {
      const label = moment().add(offset, "month").format("MMMM YYYY");
      return label.charAt(0).toUpperCase() + label.slice(1);
    },
    onToggleColumnsAndClose() {
      this.onToggleColumns();
      // Close dropdown programmatically
      this.$refs.columnsDropdown.hide();
      // Update dropdown label only when confirming
      const count = this.hiddenKeys.length;
      this.dropdownLabel = `Colonne${count > 0 ? ` (${count})` : ""}`;
    },
    onToggleColumns() {
      this.fields.forEach((field, i) => {
        if (!field.hideable) return;
        const shouldHide = this.hiddenKeys.includes(field.key);
        this.$set(this.fields[i], "thClass", shouldHide ? "d-none" : "");
        this.$set(
          this.fields[i],
          "class",
          shouldHide ? "d-none" : "align-middle",
        );
      });
    },
    salesmenOrderByName() {
      this.salesmen_select = this.salesmen;
    },
    salesmenOrderByCode() {
      this.salesmen_select = this.salesmen_ordered;
    },
    selectAllBrokers() {
      this.filter.byBrokerEnhanced.salesmen = this.getSalesmen().map(
        ({ value }) => value,
      );
    },
    deselectAllBrokers() {
      this.filter.byBrokerEnhanced.salesmen = [];
    },
    updateComment(item, target) {
      // this.hasFilterLoaded = false;
      console.log("new comment: ", item.comment);
      if (item.comment.length === 0) {
        this.deleteComment(item, target);
        return;
      }
      const payload = {
        comment: item.comment,
      };
      const Repo = RepositoryFactory.get(this.repository);
      Repo.comment_update(item.id, payload)
        .then(() => {
          if (target) {
            target.classList.remove("edited-field");
          }
          if (
            target &&
            target.previousElementSibling &&
            target.previousElementSibling.matches("svg")
          ) {
            target.previousElementSibling.classList.add("hide-it");
            target.classList.remove("hide-it-light");
          }
          this.$showSnackbar({
            preset: "success",
            text: `Azione Completata: Commento aggiornato`,
          });
        })
        .catch((error) => {
          let errMsg = this.$getErrorMessage(error);
          this.$showSnackbar({
            preset: "error",
            text: `${errMsg}`,
          });
        });
      // .finally(() => {
      //   this.hasFilterLoaded = true;
      // });
    },
    deleteComment(item, target) {
      const Repo = RepositoryFactory.get(this.repository);
      Repo.comment_destroy(item.id)
        .then(() => {
          if (target) {
            target.classList.remove("edited-field");
          }
          if (
            target &&
            target.previousElementSibling &&
            target.previousElementSibling.matches("svg")
          ) {
            target.previousElementSibling.classList.add("hide-it");
            target.classList.remove("hide-it-light");
          }
          this.$showSnackbar({
            preset: "success",
            text: `Azione Completata: Commento eliminato`,
          });
        })
        .catch((error) => {
          let errMsg = this.$getErrorMessage(error);
          this.$showSnackbar({
            preset: "error",
            text: `${errMsg}`,
          });
        });
      // .finally(() => {
      //   this.hasFilterLoaded = true;
      // });
    },
    convertErrorValues(value) {
      if (value === null) return "-";
      if (typeof value !== "number" || isNaN(value)) return "";
      return this.anomalie_errori[value] ?? "";
    },
    forcedFetch() {
      this.$refs[this.tableRef].fetch();
    },
    changeTaggable(val) {
      this.salesmen_taggable = val;
    },
    htmlToVNode(html) {
      // https://github.com/bootstrap-vue/bootstrap-vue/issues/4073
      // https://github.com/bootstrap-vue/bootstrap-vue/issues/3491
      return [this.$createElement("div", { domProps: { innerHTML: html } })];
    },
    escapeHtml(value) {
      // Escape record-derived values before injecting them into innerHTML.
      return String(value ?? "-")
        .replace(/&/g, "&amp;")
        .replace(/</g, "&lt;")
        .replace(/>/g, "&gt;")
        .replace(/"/g, "&quot;")
        .replace(/'/g, "&#39;");
    },
    initFilter() {
      let init = {
        byAttribute: {
          sent: null, // was filterOn
          payment_type: [2],
          status_payment: "0",
          // collaborazione: null, // HIDE
          salesman: null,
          // periodo: null,
          intestatario: null,
          comment: null, // custom filter TBD TODO: abilitare disabilitare cerca testo
          // note: null, // HIDE
          convenzione: null,
          // rid_polizza: null, // HIDE
          // contraenti: null,
          modificate: null,
          error_code: null,
          sepa_sdd: null,
        },
        byCustom: {
          comment: {
            value: null,
            likewise: 4,
            filter: "byAttribute",
          },
          description: {
            value: null,
            likewise: 3,
            filter: "byTask",
          },
          selected: "N",
        },
        byRelatedTasks: null,
        byCalendar: {
          from: null,
          to: null,
        },
        byInsurer: {
          id: null,
        },
        byRiskType: {
          id: null,
        },
        byRegistryGroup: {
          code: null,
        },
        byBrokerEnhanced: {
          salesmen: [],
          cooperators: [],
        },
        byRegistry: {
          id: null,
          title: null,
          status_registry: null,
          CHAN: null,
        },
        byLastInstallment: null,
        byInsurancePolicy: {
          number: null,
          payment_splitting: null,
          CONV: null,
        },
        byInsuranceAncillary: {
          status_ancillary: null,
          to_collect: null,
          consolidated: null,
        },
        byUser: {
          id: null,
        },
        byCommunicationChannel: null,
        byEmptyContact: null,
      };
      return init;
    },
    initDefaultFormValues() {
      this.$set(this.form[this.repository], "payment_type", []);
      this.$set(this.form[this.repository], "status_payment", null);
      this.$set(this.form[this.repository], "insurer_id", null);
      this.$set(this.form[this.repository], "insurance_ancillary", null);
      this.$set(this.form[this.repository], "at", null);
      this.$set(
        this.form[this.repository],
        "from",
        moment().format("M") === "12"
          ? moment().add(1, "months").add(1, "years")
          : moment().add(1, "months"),
      );
      this.$set(this.form[this.repository], "to", null);
    },
    onSendCommunications() {
      this.saveLisacomunicaAutoModal(true);
      // UNCOMMENT to FIX and properly set the breadcrumbs: must recreate the path
      // this.emptyQueue();
      // this.notifyQueue({
      //   level: 0,
      //   path: "",
      //   text: "Comunicazioni",
      // });
      // this.notifyQueue({
      //   level: 1,
      //   path: "module.COM",
      //   text: "Lisacomunica",
      // });
      // this.notifyQueue({
      //   level: 2,
      //   path: "module.PFOLIO",
      //   text: "Clienti",
      // });
      // TODO SWITCH $router push/replace when UNCOMMENT
      this.$router.push({
        name: "communication_procedures.index",
        // name: "registries.index",
        // params: { id: 1 },
      });
      // this.shortcut(
      //   "registries.edit",
      //   this.resourceId,
      //   null,
      //   null,
      //   null,
      //   {
      //     /* fromShortcut: true */
      //   },
      //   null,
      //   null,
      //   this.$options.name
      // );
    },
    onAddInsurancePayment(type) {
      // type
      //   "0":"Sospeso",
      //   "1":"Arretrato",
      //   "2":"In Scadenza (Quietanze)"
      //   "3":"Acconti"
      //   "4":"Manuale"
      // console.info(
      //   `Creazione tipo: ${type} (${
      //     this.payment_types.find((e) => e.value == type).text
      //   })`
      // );
      // NOTA: resetForm: vue-monthly-picker non funziona più quando il suo v-model ha un oggetto (moment) impostato.
      // bisogna forzare il reset del v-model, in questo caso dei campi "from", "to", "at" del form
      this.resetForm("form", "observer", [], ["to", "from", "at"]);
      this.initDefaultFormValues();
      this.pymnt = type;
      // seleziona tutte le compagnie per default, se type 0
      if (type === 2) {
        this.$refs[this.modalRef].selectAllInsurers();
      }
      this.$bvModal.show("createInsurancePaymentOptionsModal");
    },
    onDestroy(payload) {
      this.$bvModal.hide("createInsurancePaymentOptionsModal");
      payload.at = fromFirstDay(payload.at);
      this.showConfirm({
        yesCallback: () => {
          this.destroyPayment(payload);
        },
        noCallback: null,
        title: "Conferma",
        message: "Procedere con l'eliminazione?",
        yesLabel: "Procedi",
        yesVariant: "lisaweb",
        noLabel: "Annulla",
      });
    },
    destroyPayment(payload) {
      const Repo = RepositoryFactory.get(this.repository);
      Repo.bulk_destroy(payload)
        .then((response) => {
          this.$showSnackbar({
            preset: "success",
            text: `Azione Completata: ${
              response?.data > 0
                ? "Movimenti eliminati con successo"
                : "Non sono stati trovati movimenti da eliminare"
            }`,
          });
          this.$refs[this.tableRef].fetch();
        })
        .catch((error) => {
          let errMsg = this.$getErrorMessage(error);
          this.$showSnackbar({
            preset: "error",
            text: `${errMsg}`,
          });
        });
    },
    onCreate() {
      this.showConfirm({
        yesCallback: () => {
          this.storePayment();
        },
        // noCallback: () => {
        //   this.$bvModal.hide("createInsurancePaymentOptionsModal");
        // },
        noCallback: null,
        title: "Conferma",
        message: `${
          this.pymnt === 2
            ? "Procedere con la creazione del quietanzamento"
            : "Procedere con l'inclusione dei movimenti selezionati?"
        }`,
        yesLabel: "Procedi",
        yesVariant: "primary",
        noLabel: "Annulla",
        // yesVariant:
        // noVariant:
        // headerBgVariant:
      });
    },
    storePayment() {
      let tableRef = this.$refs[this.tableRef];
      this.isLoading = false;
      this.hasFilterLoaded = false;
      this.$bvModal.hide("createInsurancePaymentOptionsModal");
      // from potrebbe essere vuoto => 01/01/1900
      if (!this.form[this.repository].from) {
        this.form[this.repository].from = "1900-01-01";
      }
      // let id;
      let e, s, s1, s2;
      // prepare the period
      switch (this.pymnt) {
        case 0:
        case 1:
        case 3:
          // "Mese" fa 2 cose:
          e = toLastDay(this.form[this.repository].from);
          s1 = fromFirstDay(this.form[this.repository].from);
          s2 = this.form[this.repository].to
            ? fromFirstDay(this.form[this.repository].to)
            : "1900-01-01";
          // - invia il giorno AL (ultimo giorno del mese scelto) nel periodo già inviato
          this.form[this.repository].to = e;
          // - invia a parte il primo giorno del mese come periodo (nuovo parametro da #185)
          this.form[this.repository].at = s1;
          // "Fino a" diventa "escludi antecedenti al" e invia il primo giorno del mese scelto come DAL (nel periodo di ricerca per BE).
          this.form[this.repository].from = s2;
          // remove forbidden fields
          this.$delete(this.form[this.repository], "insurance_ancillary");
          break;
        case 2:
          // c'è solo 1 datepicker => imposto from e to rispettivamente con 1° e ultimo giorno del mese selezionato
          // add 1st day of month to "from", last day of month to "to"
          s = fromFirstDay(this.form[this.repository].from);
          e = toLastDay(this.form[this.repository].from);
          // set the calculated form values
          this.form[this.repository].from = s;
          this.form[this.repository].to = e;
          // remove forbidden fields
          this.$delete(this.form[this.repository], "insurance_ancillary");
          this.$delete(this.form[this.repository], "at");
          break;
        case 4: // CHECK the correct type id
          // Invia a BE
          // - ID titolo
          // CHECK come inviare this.form[this.repository].insurance_ancillary_id ???
          // this.form[this.repository].insurance_ancillary = {
          //   [this.form[this.repository].insurance_ancillary_id]: {},
          // };
          // this.form[this.repository].insurance_ancillary =
          //   this.form[this.repository].insurance_ancillary_id;
          // - la data di scadenza scelta dall'operatore ("at", obbligatoria nella modale): il BE
          //   tiene comunque una sola quietanza manuale per titolo e mese
          // remove forbidden fields
          this.$delete(this.form[this.repository], "to");
          this.$delete(this.form[this.repository], "from");
          break;
        default:
          // ci sono 2 datepicker, in from metto 1° giorno del datepicker #1, in to metto ultimo del datepicker #2
          s = fromFirstDay(this.form[this.repository].from);
          e = toLastDay(this.form[this.repository].to);
          // set the calculated form values
          this.form[this.repository].from = s;
          this.form[this.repository].to = e;
          break;
      }
      let records = 0;
      this.store(this.repository)
        .then((response) => {
          records = response.data.data.length;
          // this.onSearch(this.filterName);
          let criteria = this.filter;
          let name = this.filterName;
          this.saveFilterByName({ name, criteria });
          this.removePaginationByName(name);
          tableRef.currentPage = 1;
          tableRef
            .fetch()
            .then(() => {
              tableRef
                .loadSelectedCounter()
                .then(() => {
                  // this.isLoading = false;
                  this.getLastCreated()
                    .then(() => {
                      this.$showSnackbar({
                        preset: "success",
                        text: `${
                          records
                            ? this.pymnt === 2
                              ? "Quietanzamento creato con successo"
                              : "Inclusione movimenti completata"
                            : this.pymnt === 2
                            ? "Nessuna nuova quietanza generata"
                            : "Non sono stati trovati movimenti da includere"
                        }`,
                      });
                    })
                    .catch((error) => {
                      let errMsg = this.$getErrorMessage(error);
                      this.$showSnackbar({ preset: "error", text: errMsg });
                    })
                    .finally(() => {
                      // this.isLoading = false;
                      this.hasFilterLoaded = true;
                    });
                })
                .catch((error) => {
                  let errMsg = this.$getErrorMessage(error);
                  this.$showSnackbar({
                    preset: "error",
                    text: `${errMsg}`,
                  });
                });
            })
            .catch((error) => {
              let errMsg = this.$getErrorMessage(error);
              this.$showSnackbar({
                preset: "error",
                text: `${errMsg}`,
              });
            });
        })
        .catch((error) => {
          let errMsg = this.$getErrorMessage(error);
          this.$showSnackbar({
            preset: "error",
            text: `${errMsg}`,
          });
        })
        .finally(() => {
          this.$refs[this.modalRef].close();
          // this.isLoading = false;
          // this.hasFilterLoaded = true;
        });
    },
    onSelectAll() {
      this.filterUpdate("spunta");
    },
    onUnselectAll() {
      this.uncheckSelected();
    },
    /*
     * Spunta/toglie la spunta alle sole quietanze della pagina corrente: a differenza di
     * "Spunta tutte" non usa il filtro della ricerca ma gli id delle righe caricate, e non
     * ricarica la tabella così l'utente resta sulla pagina in cui si trova.
     */
    onSelectPage(selected) {
      let tableRef = this.$refs[this.tableRef];
      const items = tableRef.pageSelectableItems.filter(
        (item) => item.selected.value !== selected,
      );
      if (!items.length) return;
      let queryString = `byAttribute[id]=${items
        .map((item) => item.id)
        .join(",")}`;
      let payload = {
        related: {
          users: {
            [this.userId]: {
              selected: selected,
            },
          },
        },
      };
      this.isLoadingSpunte = true;
      let Repo = RepositoryFactory.get(this.repository);
      Repo.filter_update(payload, queryString)
        .then(() => {
          items.forEach((item) => {
            item.selected.value = selected;
            item.selected.text = selected === "Y" ? "Si" : "No";
            // calculateItemSelected() ricava la spunta da users a ogni render
            item.users = selected === "Y" ? [{ id: this.userId }] : [];
          });
          return tableRef.loadSelectedCounter();
        })
        .catch((error) => {
          let errMsg = this.$getErrorMessage(error);
          this.$showSnackbar({ preset: "error", text: `${errMsg}` });
        })
        .finally(() => {
          this.isLoadingSpunte = false;
        });
    },
    uncheckSelected() {
      let tableRef = this.$refs[this.tableRef];
      let Repo = RepositoryFactory.get(this.repository);
      Repo.uncheck_selected()
        .then(() => {
          tableRef.loadSelectedCounter();
          this.$showSnackbar({
            preset: "success",
            text: `Spunte tolte con successo`,
          });
          this.onSearch(this.filterName);
        })
        .catch((error) => {
          let errMsg = this.$getErrorMessage(error);
          this.$showSnackbar({ preset: "error", text: `${errMsg}` });
        });
    },
    filterUpdate(mode) {
      this.isLoadingSpunte = true;
      let filter;
      let queryString;
      let qs = {};
      let payload = {
        related: {
          users: {
            [this.userId]: {
              selected: null,
            },
          },
        },
      };
      let tableRef = this.$refs[this.tableRef];
      const rgx = /(byAttribute\[status_payment\]=.{1})/;
      switch (mode) {
        case "spunta":
          payload.related = { users: { [this.userId]: { selected: "Y" } } };
          filter = tableRef.loadFilter(tableRef.filterName);
          if (filter) {
            qs.filter = filter;
            if (qs.filter.indexOf("byAttribute[status_payment]") >= 0) {
              qs.filter = qs.filter.replace(
                rgx,
                "byAttribute[status_payment]=0",
              );
            } else {
              qs.filter += "&byAttribute[status_payment]=0";
            }
            queryString = Object.values(qs).join("&");
          } else {
            let criteria = this.filter;
            queryString = prepareFilterQueryString(criteria);
            queryString += "byAttribute[status_payment]=0";
          }
          break;
        default:
          break;
      }
      let Repo = RepositoryFactory.get(this.repository);
      this.isLoading = true;
      this.isLoadingSpunte = true;
      Repo.filter_update(payload, queryString)
        .then(() => {
          // do not fetch, just loadSelectedCounter()
          tableRef.loadSelectedCounter();
          // then set all checkboxes of all items in this page
          tableRef.items.forEach((item) => {
            item.selected.value = payload.related.users[this.userId].selected;
          });
          this.isLoading = false;
          this.isLoadingSpunte = true;
          this.$showSnackbar({
            preset: "success",
            text: `Spunte aggiunte con successo`,
          });
          // this.$refs[this.tableRef].fetch();
          this.onSearch(this.filterName);
        })
        .catch((error) => {
          let errMsg = this.$getErrorMessage(error);
          this.$showSnackbar({
            preset: "error",
            text: `${errMsg}`,
          });
        })
        .finally(() => {
          this.isLoading = false;
          this.isLoadingSpunte = false;
        });
    },
    onUpdateSelected(row, checkboxElement) {
      this.updateSelected(row, checkboxElement);
    },
    updateSelected(row, checkboxElement) {
      // console.log("updateSelected", checkboxElement);
      let queryString = `byAttribute[id]=${row.id}`;
      let payload = {
        related: {
          users: {
            [this.userId]: {
              selected: row.selected.value,
            },
          },
        },
      };
      let tableRef = this.$refs[this.tableRef];
      let Repo = RepositoryFactory.get(this.repository);
      console.log("payload: ", payload);
      Repo.filter_update(payload, queryString)
        .then(() => {
          // this.$showSnackbar({
          //   preset: "success",
          //   text: `Aggiornato con successo`,
          // });
          // calculateItemSelected() ricava la spunta da users a ogni render, e intanto
          // può aver già riportato row.selected al valore precedente: si usa quello inviato
          row.users =
            payload.related.users[this.userId].selected === "Y"
              ? [{ id: this.userId }]
              : [];
          // do not fetch, just loadSelectedCounter()
          tableRef.loadSelectedCounter();
        })
        .catch((error) => {
          let errMsg = this.$getErrorMessage(error);
          this.$showSnackbar({
            preset: "error",
            text: `${errMsg}`,
          });
        })
        .finally(() => {
          if (checkboxElement && checkboxElement.previousElementSibling) {
            checkboxElement.previousElementSibling.classList.add("hide-it");
            checkboxElement.classList.remove("hide-it");
          }
        });
    },
    onUpdateStatus(row) {
      let actualText = this.status_payments.find(
        (el) => el.value == row.status_payment.value,
      ).text;
      let newText = this.status_payments.find(
        (el) => el.value != row.status_payment.value,
      ).text;
      const policy_id = row?.payable?.insurance_policy?.id;
      const status_payment = row?.status_payment?.value;
      const status_policy_id =
        row?.payable?.insurance_policy?.status_policy?.value;
      let new_policy;
      let msg = `Cambiare stato da: ${actualText} a: ${newText}?`;
      if (policy_id && status_payment === 1 && status_policy_id === 3) {
        this.isLoading = true;
        let filter = `relations/byBroker/byCollaborator/byRegistry/byInsurer/byInsurerParticipant/byInsuranceRisk/byNewPolicy/byOldPolicy`;
        let queryString = `${filter ? filter : ""}`;
        this.fetchShowForm("insurance_policy", policy_id, queryString)
          .then((response) => {
            const data = response.data.data;
            new_policy = data.new_policies[0];
            if (new_policy) {
              msg = `
                  <div class="custom-grid-wrapper">
                    <p style="background: #E1DDDA;padding: 4px 8px;grid-column: 1 / span 2;margin: 0;"><strong style="text-transform: uppercase;">Vuoi procedere con il cambio di stato di questa quietanza?</strong></p>
                    <strong>Cambio stato</strong><span>Da: ${this.escapeHtml(
                      actualText,
                    )} a: ${this.escapeHtml(newText)}</span>
                    <strong>Compagnia</strong><span>${this.escapeHtml(
                      data?.insurer?.code,
                    )}</span>
                    <strong>Polizza di riferimento</strong><span>${this.escapeHtml(
                      data?.number,
                    )}</span>
                    <strong>Errore riscontrato</strong><span>${this.escapeHtml(
                      getVirtualValue("errors", row),
                    )}</span>
                    <strong>Intestatario</strong><span>${this.escapeHtml(
                      data?.registry?.formatted_title,
                    )}</span>
                    <strong>Scadenza</strong><span>${
                      data?.expired_at
                        ? moment(data.expired_at).format("DD/MM/YYYY")
                        : "-"
                    }</span>
                    <strong>Premio</strong><span>${
                      data?.gross_premium
                        ? toLocaleCurrency(data.gross_premium)
                        : "-"
                    }</span>
                    <p style="background: #E1DDDA;padding: 4px 8px;grid-column: 1 / span 2;margin: 0;"><strong style="text-transform: uppercase;">L'avviso di pagamento verrà creato per la seguente polizza sostituente</strong></p>
                    <strong>Compagnia</strong><span>${this.escapeHtml(
                      new_policy?.insurer?.code,
                    )}</span>
                    <strong>Numero polizza</strong><span>${this.escapeHtml(
                      new_policy?.number,
                    )}</span>
                    <strong>Contraente</strong><span>${this.escapeHtml(
                      new_policy?.registry?.formatted_title,
                    )}</span>
                    <strong>Produttore</strong><span>${this.escapeHtml(
                      new_policy?.broker_id
                        ? this.salesmen.find(
                            (e) => e.value == new_policy.broker_id,
                          )?.text
                        : "-",
                    )}</span>
                    <strong>Ramo-Rischio</strong><span>${this.escapeHtml(
                      new_policy?.insurance_risk?.risk_branch?.code,
                    )}-${this.escapeHtml(
                new_policy?.insurance_risk?.code,
              )}</span>
                    <strong>Stato</strong><span>${this.escapeHtml(
                      new_policy?.status_policy?.text,
                    )}</span>
                    <strong>Data decorrenza contratto</strong><span>${
                      new_policy?.effective_at
                        ? moment(new_policy.effective_at).format("DD/MM/YYYY")
                        : "-"
                    }</span>
                    <strong>Data scadenza contratto</strong><span>${
                      new_policy?.expired_at
                        ? moment(new_policy.expired_at).format("DD/MM/YYYY")
                        : "-"
                    }</span>
                    <strong>Data di copertura</strong><span>${
                      new_policy?.covered_at
                        ? moment(new_policy.covered_at).format("DD/MM/YYYY")
                        : "-"
                    }</span>
                    <strong>Data sospensione</strong><span>${
                      new_policy?.suspended_at
                        ? moment(new_policy.suspended_at).format("DD/MM/YYYY")
                        : "-"
                    }</span>
                    <strong>Rateazione</strong><span>${this.escapeHtml(
                      new_policy?.payment_splitting?.text,
                    )}</span>
                    <strong>Tacito rinnovo</strong><span>${this.escapeHtml(
                      new_policy?.attributables?.RENW,
                    )}</span>
                    <strong>Indicatore di polizza disdetta</strong><span>${this.escapeHtml(
                      new_policy?.attributables?.LNOT,
                    )}</span>
                    <strong>Premio polizza</strong><span>${
                      new_policy?.gross_premium
                        ? toLocaleCurrency(new_policy.gross_premium)
                        : "-"
                    }</span>
                  </div>
                `;
              msg = this.htmlToVNode(msg);
            }
            this.showConfirm({
              yesCallback: () => {
                this.updateStatus(row);
              },
              noCallback: null,
              title: "Conferma",
              message: msg,
              yesLabel: "Cambia",
              yesVariant: "outline-lisaweb",
              noLabel: "Annulla",
              size: "md",
            });
          })
          .catch((error) => {
            console.error(error);
          })
          .finally(() => {
            this.isLoading = false;
          });
      } else {
        this.showConfirm({
          yesCallback: () => {
            this.updateStatus(row);
          },
          noCallback: null,
          title: "Conferma",
          message: msg,
          yesLabel: "Cambia",
          yesVariant: "outline-lisaweb",
          noLabel: "Annulla",
        });
      }
      // let msg = `Cambiare stato da: ${actualText} a: ${newText}?`;
      // msg += `<p><strong>test</strong><br />questo è un testo.</p>`;
      // msg = this.htmlToVNode(msg);
      // this.showConfirm({
      //   yesCallback: () => {
      //     this.updateStatus(row);
      //   },
      //   noCallback: null,
      //   title: "Conferma",
      //   message: msg,
      //   yesLabel: "CAMBIA",
      //   yesVariant: "outline-lisaweb",
      //   noLabel: "ANNULLA",
      //   // yesVariant:
      //   // noVariant:
      //   // headerBgVariant:
      // });
    },
    updateStatus(row) {
      let form = {
        status_payment: null,
        modified: "Y",
      };
      switch (row.status_payment.value) {
        case 0:
          form.status_payment = 1;
          break;
        case 1:
        case 2:
          form.status_payment = 0;
          break;
      }
      console.log("Form: ", form);
      let tableRef = this.$refs[this.tableRef];
      this.update(this.repository, row.id, form)
        .then(() => {
          this.$showSnackbar({
            preset: "success",
            text: `Stato cambiato con successo`,
          });
          // do not fetch, just loadSelectedCounter()
          // set the status_payment.value to update the icon and also "Stato" field's text
          tableRef.items.find((item) => item.id == row.id).modified.value = "Y";
          tableRef.items.find(
            (item) => item.id == row.id,
          ).status_payment.value = form.status_payment;
          tableRef.items.find((item) => item.id == row.id).status_payment.text =
            this.status_payments.find(
              (status_payment) => status_payment.value == form.status_payment,
            ).text;
        })
        .catch((error) => {
          let errMsg = this.$getErrorMessage(error);
          this.$showSnackbar({
            preset: "error",
            text: `${errMsg}`,
          });
        });
    },
    openConsolidateModal() {
      const tableRef = this.$refs[this.tableRef];
      /* Stesso filtro della griglia: quello persistito, o quello a schermo se non ancora salvato */
      this.consolidateQueryString =
        tableRef.loadFilter(tableRef.filterName) ||
        prepareFilterQueryString(this.filter);
      this.consolidateTotal = tableRef.totalItems;
      this.$bvModal.show("consolidateModal");
    },
    onConsolidate(value) {
      this.consolidate(value, this.consolidateQueryString);
    },
    consolidate(value, queryString) {
      this.isConsolidating = true;
      let Repo = RepositoryFactory.get(this.repository);
      Repo.filter_consolidate({ consolidated: value }, queryString)
        .then((response) => {
          /* Il consolidamento è del titolo: affected conta i titoli delle quietanze filtrate */
          const affected = response?.data?.data?.affected ?? 0;
          this.$showSnackbar({
            preset: affected ? "success" : "info",
            text: affected
              ? `Titoli aggiornati: ${affected}`
              : `Nessun titolo aggiornato`,
          });
          this.onSearch(this.filterName);
        })
        .catch((error) => {
          let errMsg = this.$getErrorMessage(error);
          this.$showSnackbar({ preset: "error", text: `${errMsg}` });
        })
        .finally(() => {
          this.isConsolidating = false;
        });
    },
    /*
     * L'incassabilità è del titolo: la griglia emette il titolo della quietanza e si scrive
     * sulla sua risorsa. Nessuna conferma: il toggle è reversibile finché non è consolidato.
     */
    onToggleToCollect(ancillary) {
      let Repo = RepositoryFactory.get("insurance_ancillary");
      const wasToCollect = ancillary.to_collect.value === "Y";
      const value = wasToCollect ? "N" : "Y";
      Repo.to_collect_update(ancillary.id, { to_collect: value })
        .then(() => {
          /* Aggiorna la riga in locale, senza rifare la fetch */
          ancillary.to_collect.value = value;
          ancillary.to_collect.text = wasToCollect ? "No" : "Sì";
          this.$showSnackbar({
            preset: "success",
            text: `Titolo reso ${
              wasToCollect ? "non incassabile" : "incassabile"
            }`,
          });
        })
        .catch((error) => {
          let errMsg = this.$getErrorMessage(error);
          this.$showSnackbar({ preset: "error", text: `${errMsg}` });
        });
    },
    customFilterName(key, prefix = "byAttribute") {
      return `${prefix}.${key}`;
    },
    getLastCreated() {
      const Repo = RepositoryFactory.get("insurance_payment");
      return Repo.index("byLastCreated").then((response) => {
        this.lastCreated =
          response.data && response.data.data.length
            ? response.data.data[0].last_created
            : null;
        // set period
        // this.period = moment(this.lastCreated);
        // set from and to
        // this.filter.byCalendar.from = fromFirstDay(this.lastCreated);
        // this.filter.byCalendar.to = toLastDay(this.lastCreated);
        /* */
        // se non c'è già un filtro salvato, imposto i valori di default a byCalendar
        let found = this.loadFilter(this.filterName);
        if (!found) {
          this.filter.byCalendar.from = fromFirstDay(this.lastCreated);
          this.filter.byCalendar.to = toLastDay(this.lastCreated);
        } else if (
          JSON.stringify(this.initFilter()) !== JSON.stringify(found)
        ) {
          this.onSearch(this.filterName);
        } else {
          /* Default values at 2nd render - DO NOTHING */
        }
        this.hasFilterLoaded = true;
        /* */
      });
    },
    onEdit(id) {
      this.$router.push({
        name: `${this.resource}.edit`,
        params: { id: `${id}` },
      });
    },
    manipolaItems(data) {
      data.forEach((item) => {
        if (!item.selected) {
          item["selected"] = { text: "", value: null };
        }
        if (item.users.length) {
          item.selected.value = "Y";
          item.selected.text = "Si";
        } else {
          item.selected.value = "N";
          item.selected.text = "No";
        }
      });
      return data;
    },
    manualFetch() {
      this.resetAllFilters();
    },
    retriveActiveFilters(obj = this.filter, parentKey = "") {
      for (const key in obj) {
        const value = obj[key];
        // Build the property path (for nested properties)
        const fullPath = parentKey ? `${parentKey}.${key}` : key;

        if (key === "byCustom" && typeof value === "object") {
          for (const innerKey in value) {
            const innerValue = value[innerKey];

            // Case A: For objects like 'comment' { value: '...', ... }
            if (
              innerValue &&
              typeof innerValue === "object" &&
              "value" in innerValue
            ) {
              if (innerValue.value !== null && innerValue.value !== "") {
                this.activeFilters[`${fullPath}.${innerKey}.value`] =
                  innerValue.value;
              }
            }
            // Case B: NEW - For simple strings like 'selected': 'Y'
            else if (innerValue !== null && innerValue !== "") {
              // This creates the key "byCustom.selected" in your activeFilters object
              this.activeFilters[`${fullPath}.${innerKey}`] = innerValue;
            }
          }
        } else if (value && Array.isArray(value)) {
          if (value.length === 1) {
            this.activeFilters[fullPath] = value[0];
          } else if (value.length > 1) {
            // If it's an array don't print all the values recorsively
            this.activeFilters[fullPath] = `${value.length} selezioni`;
          }
        } else if (value && typeof value === "object") {
          // Recursively process nested objects for non-`byCustom` keys
          Object.assign(
            this.activeFilters,
            this.retriveActiveFilters(value, fullPath),
          );
        } else if (value !== null && String(value).length) {
          // Append non-null values
          this.activeFilters[fullPath] = value;
        }
      }
      delete this.activeFilters["byUser.id"];
      return this.activeFilters;
    },
    onSearch(name) {
      this.performedSearch = true;
      this.activeFilters = {};
      this.activeFilters = this.retriveActiveFilters();
      if (this.filter.byCustom.description.value) {
        if (!this.$refs[this.tableRef].filterOn.byRelations.includes("byTask"))
          this.$refs[this.tableRef].filterOn.byRelations.push("byTask");
      } else {
        const index =
          this.$refs[this.tableRef].filterOn.byRelations.indexOf("byTask");
        if (index !== -1) {
          this.$refs[this.tableRef].filterOn.byRelations.splice(index, 1);
        }
      }
      this.filter.byUser.id =
        this.filter?.byCustom?.selected === "Y"
          ? this.$store.state.auth.user.id
          : null;
      let criteria = this.filter;
      this.saveFilterByName({ name, criteria });
      let extra_info = this.extra_group_full_info;
      this.saveFilterExtraGroupByName({ name, extra_info });
      this.exportUrl = this.$refs[this.tableRef].loadFilter(
        this.$refs[this.tableRef].filterName,
      );
      /* */
      criteria = {};
      ["quickSearchGroup"].forEach((element) => {
        criteria[element] = {
          label: "",
          formLabel: "",
          data: null,
          formData: null,
        };
      });
      criteria.quickSearchGroup.label = this.form.inpt_label_group;
      criteria.quickSearchGroup.formLabel = "form.inpt_label_group";
      criteria.quickSearchGroup.data = this.group_data;
      criteria.quickSearchGroup.formData = "group_data";
      this.saveQuickSearchByName({ name, criteria });
      /* */
      this.removePaginationByName(name);
      this.$refs[this.tableRef].currentPage = 1;
      // args
      this.args = {
        items: { handle: null, params: [], filtered: false },
        verb: {},
      };
      this.args.items.handle = this.manipolaItems;
      this.$refs[this.tableRef].fetch(this.args).then(() => {
        // this.removeFilterByName(name); // WARNING: need to keep the filter because of filter_update must preserve the selection
        this.$refs[this.tableRef].loadSelectedCounter();
      });
    },
    onClearFilter(name) {
      this.resetGroupId();
      this.resetFilter();
      this.getLastCreated(); // set from e to
      // this.period = null; // month-picker
      this.resetPagination();
      this.removeFilterByName(name);
      this.removePaginationByName(name);
      this.removeSortByName(name);
      this.$refs[this.tableRef].sortBy = "";
      this.$refs[this.tableRef].sortDesc = false;
      // this.onSearch(name);
    },
    onClearPeriod() {
      // TODO: quando wallace avrà deciso il nome del campo per byLastcreated..
      // this.showConfirm({
      //   yesCallback: () => {
      //     this.period = null;
      //   },
      //   noCallback: () => {
      //     this.period = this.lastCreated;
      //   },
      //   title: "Conferma Reset",
      //   message: `Pulire il campo o ripristinare al valore di default (${moment(
      //     this.lastCreated
      //   ).format("MM/YYYY")})?`,
      //   yesLabel: "PULISCI",
      //   noLabel: "RIPRISTINA",
      //   yesVariant: "outline-success",
      //   noVariant: "outline-lisaweb",
      //   // headerBgVariant:
      // });
    },
    openReplacedPolicyModal(policy_id) {
      this.old_replaced_policy_id = this.replaced_policy_id;
      this.replaced_policy_id = policy_id;
      if (this.old_replaced_policy_id === this.replaced_policy_id) {
        this.$bvModal.show("replacedPolicyDetailModal");
      }
    },
    openAddressBook(row) {
      let found;
      this.old_address_book_id = this.new_address_book_id;
      const address_books =
        row?.item?.payable?.insurance_policy?.registry?.address_books;
      if (address_books && address_books?.length) {
        found = address_books.find((e) => e.status_addressbook.value === 0);
        if (found) this.new_address_book_id = found.id;
      }
      this.old_correspondence_id = this.new_correspondence_id;
      const correspondences =
        row?.item?.payable?.insurance_policy?.registry?.correspondences;
      if (correspondences && correspondences?.length) {
        found = correspondences.find(
          (e) => e.status_correspondence.value === 1,
        );
        if (found) this.new_correspondence_id = found.id;
      }
      this.old_registry_id = this.new_registry_id;
      this.new_registry_id = row?.item?.payable?.insurance_policy?.registry?.id;
      this.registry_obj = {
        registry_id: this.new_registry_id,
        address_book_id: this.new_address_book_id,
        correspondence_id: this.new_correspondence_id,
      };
      if (this.old_registry_id === this.new_registry_id) {
        this.$bvModal.show("addressBookEditModal");
      }

      // this.resourceId = row
      // this.$bvModal.show("addressBookEditModal");
    },
    handleGroupModalInput(value) {
      this.filter.byRegistryGroup.code = value.code;
      this.group_data = value;
      this.form.inpt_label_group = this.toInfoData(
        this.group_data,
        "registry_group",
      );
      this.extra_group_full_info = this.toInfoData(
        this.group_data,
        "registry_group_full",
        null,
        "",
      );
      this.$bvModal.hide("quickSearchGroupModal");
    },
    openQuickSearchGroup() {
      this.filter.byRegistryGroup.code = null;
      this.$bvModal.show("quickSearchGroupModal");
    },
    resetGroupId() {
      this.group_data = null;
      this.form.inpt_label_group = null;
      this.filter.byRegistryGroup.code = null;
      this.extra_group_full_info = null;
    },
    // ...mapActions("queue", ["notifyQueue", "emptyQueue"]),
    ...mapActions("filters", {
      saveFilterByName: "saveByName",
      saveFilterExtraGroupByName: "saveExtraGroupByName",
      removeFilterByName: "removeByName",
    }),
    ...mapActions("quicksearch", {
      saveQuickSearchByName: "saveByName",
      removeQuickSearchByName: "removeByName",
    }),
    ...mapActions("pagination", { removePaginationByName: "removeByName" }),
    ...mapActions("sorts", {
      removeSortByName: "removeByName",
    }),
    // onSaveFilter(name, criteria) {
    //   console.debug(`onSaveFilter criteria: ${JSON.stringify(criteria)}`);
    //   this.saveFilterByName({ name, criteria });
    // },
    ...mapActions("lisacomunica_automodal", ["saveLisacomunicaAutoModal"]),
    //Getters
    ...mapGetters("auth", {
      getInsurers: "insurers",
      getRisks: "risks",
      getSalesmen: "salesmen",
      getSalesmenOrderedByCode: "salesmen_orderd_by_code",
      // getCooperators: "cooperators",
    }),
  },
  mounted() {
    this.companies = this.getInsurers();
    this.risks = this.getRisks();
    this.risks.sort((a, b) => {
      if (a.text < b.text) return -1;
      if (a.text > b.text) return 1;
      return 0;
    });
    this.salesmen = this.getSalesmen();
    // this.cooperators = this.getCooperators();
    // Initialize hiddenKeys from current field classes (if any are already hidden)
    this.hiddenKeys = this.fields
      .filter(
        (f) =>
          f.hideable &&
          /(?:^|\s)d-none(?:\s|$)/.test(
            (f.thClass || "") + " " + (f.class || ""),
          ),
      )
      .map((f) => f.key);
  },
  beforeMount() {
    // this.initDefaultFormValues();
    this.salesmen = this.getSalesmen();
    this.salesmen_select = this.getSalesmen();
    this.salesmen_ordered = this.getSalesmenOrderedByCode();
    this.fetchCreateForm(this.repository)
      .then(() => {
        // set select options:
        // this.payment_types = this.beForm[this.repository].payment_type.options; // li vogliono hard-coded
        // also load counter
        this.$refs[this.tableRef].loadSelectedCounter();
        // TODO: quando wallace avrà deciso il nome del campo per byLastcreated..
        // and also byLastCreated
        this.getLastCreated()
          .then(() => {
            this.formLoaded = true; // TODO toglierlo dal finally
            let found = this.loadFilter(this.filterName);
            if (!found) {
              // this.filter.byCalendar.from = this.lastCreated;
              // this.filter.byCalendar.to = this.lastCreated;
              this.activeFilters = {};
              this.activeFilters = this.retriveActiveFilters();
              this.open_filter = true;
            }
          })
          .catch((error) => {
            let errMsg = this.$getErrorMessage(error);
            this.$showSnackbar({
              preset: "error",
              text: `${errMsg}`,
            });
          });
      })
      .catch((error) => {
        let errMsg = this.$getErrorMessage(error);
        this.$showSnackbar({
          preset: "error",
          text: `${errMsg}`,
        });
      })
      .finally(() => {
        this.formLoaded = true;
      });
  },
  // watch: {
  //   [this.isLoading]: {
  //     handler: function (value) {
  //       console.debug("currentPage:", value, this.currentPage);
  //       console.debug("perPage:", this.perPage);
  //       this.canSearch = value
  //     },
  //   },
  // },
};
</script>
<style lang="scss" scoped>
[data-table="quietanzamento"] .row:has(.pagination) {
  margin: 0;
}

[data-table="quietanzamento"] thead tr th:nth-child(4),
[data-table="quietanzamento"] tbody tr td:nth-child(4) {
  display: none;
}

:deep(.b-dropdown-form) {
  font-size: 0.8rem;
}

:deep(.b-dropdown-form .btn) {
  width: 100%;
}

:deep(.btn-group > .btn) {
  font-size: 0.75rem;
}

:deep(.dropdown-header) {
  font-size: 0.75rem;
  padding: 0.25rem 1.1rem;
  font-weight: 500;
  color: var(--color-text);
}

:deep(.dropdown-menu.show) {
  min-width: fit-content;
  margin: 6px 0 0 -7px;
  border: 2px solid var(--color-text);
  border-radius: 0.5rem;
}

:deep(.custom-checkbox),
:deep(.custom-checkbox *) {
  cursor: pointer;
}

/* Metriche delle voci allineate al menu Esporta, dove sono scoped su ExportOptions.vue */
:deep(.actions-dropdown .dropdown-item) {
  font-size: 0.75rem;
  padding: 0.25rem 0.75rem;
}

/* Separatore fra categorie: equivalente strutturale della regola globale
   `ul li + li header#dropdown-header-pdf` di custom.scss, cablata su un id fisso */
:deep(.actions-dropdown .dropdown-menu li + li > .dropdown-header) {
  padding-top: 10px;
  border-top: 1px solid var(--gray-300);
  margin-top: 10px;
}
</style>
